import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import cls from 'classnames';
import { useToggle } from '@cutwise/react-utils';
import Avatar from '@/common/components/Avatar/Avatar';
import AvatarsList from '@/common/components/AvatarsList/AvatarsList';
import FancyTooltip from '@/common/components/FancyTooltip/FancyTooltip';
import Icon from '@/common/components/Icon/Icon';
import PrivateAccessModal from '../PrivateAccessModal/PrivateAccessModal';
import styles from './ACLStatus.module.css';
const SIZE_CLASS_MAP = {
    small: styles.aclAddButtonSmall,
    medium: styles.aclAddButtonMedium,
    large: styles.aclAddButtonLarge,
};
function ACLStatus(props) {
    const { product, project, size = 'medium', isCreatable, onUpdate } = props;
    const [isPersonalShareModalOpen, openPersonalShareModal, closePersonalShareModal] = useToggle();
    const entity = (product ?? project);
    if (!entity) {
        return null;
    }
    function onClickHandler(e) {
        e.preventDefault();
        e.stopPropagation();
        if (!isCreatable) {
            return;
        }
        openPersonalShareModal();
    }
    function renderACLList(assignees) {
        if (assignees.length === 0) {
            return null;
        }
        return (_jsx("div", { children: assignees.map((assignee) => {
                return (_jsxs("div", { className: styles.aclAssignee, children: [_jsx(Avatar, { size: "small", username: assignee.name }), _jsx("span", { children: assignee.name })] }, assignee.getAssigneeId()));
            }) }));
    }
    const type = product ? 'product' : 'project';
    const assignees = [
        ...entity.acl.map(({ assignee }) => assignee),
        ...entity.accessGroupAcl.map(({ accessGroup }) => accessGroup),
    ];
    const shownAssignees = assignees.slice(0, 3);
    return (_jsxs(Fragment, { children: [_jsxs("div", { className: cls(styles.aclStatus, { [styles.interactive]: isCreatable }), children: [isCreatable && shownAssignees.length === 0 && (_jsx("button", { className: cls(styles.aclAddButton, SIZE_CLASS_MAP[size]), type: "button", onClick: onClickHandler, children: _jsx(Icon, { className: styles.aclAddButtonIcon, name: "add-person" }) })), shownAssignees.length > 0 && (_jsx(FancyTooltip, { content: renderACLList(assignees), placement: "bottom", usePortal: true, shouldStayOnHover: true, children: _jsx("div", { onClick: onClickHandler, children: _jsx(AvatarsList, { avatars: shownAssignees.map((assignee) => ({ username: assignee.name })), size: size }) }) }))] }), _jsx(PrivateAccessModal, { entities: [entity], isOpen: isPersonalShareModalOpen, onClose: closePersonalShareModal, onSuccess: onUpdate, type: type })] }));
}
export default ACLStatus;
